import { DownOutlined, FormOutlined } from "@ant-design/icons";
import { Input, Modal, Dropdown, Typography, Table, Space, Menu } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useState } from "react";
import { DataType, IAddStudents } from "types";

export const AddStudentModal: React.FC<IAddStudents> = ({ ...props }) => {
	const [selectedValue, setSelecteValue] = useState<string>("10");

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		courseStatus,
		setCourseStatus,
		currentCourseData,
		setIsOpenNewStudentModal,
	} = props;
	const menu = (
		<Menu
			selectable
			// @ts-ignore
			onClick={(e) => setSelecteValue(e.key)}
			defaultSelectedKeys={["3"]}
			items={[
				{
					key: "10",
					label: "10",
				},
				{
					key: "20",
					label: "20",
				},
				{
					key: "30",
					label: "30",
				},
				{
					key: "40",
					label: "40",
				},
			]}
		/>
	);

	const columns: ColumnsType<DataType> = [
		{
			title: "Nome do usuário",
			dataIndex: "name",
			key: "name",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
			onCell: () => {
				return {
					width: "16%",
				};
			},
		},
		{
			title: "E-mail",
			dataIndex: "email",
			key: "email",
		},
		{
			title: "Data de inclusão",
			dataIndex: "start_access",
			key: "start_access",
			onCell: () => {
				return {
					width: "15%",
				};
			},
		},
		{
			title: "Incluso até",
			dataIndex: "end_access",
			key: "end_access",
			onCell: () => {
				return {
					width: "12.5%",
				};
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			onCell: () => {
				return {
					width: "10%",
				};
			},
		},
		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined className="edit" />
				</Space>
			),
			onCell: () => {
				return {
					width: "10%",
				};
			},
		},
	];

	const data: DataType[] = [
		{
			key: "1",
			name: "John Brown",
			age: 32,
			address: "New York No. 1 Lake Park",
			tags: ["nice", "developer"],
		},
		{
			key: "2",
			name: "Jim Green",
			age: 42,
			address: "London No. 1 Lake Park",
			tags: ["loser"],
		},
		{
			key: "3",
			name: "Joe Black",
			age: 32,
			address: "Sidney No. 1 Lake Park",
			tags: ["cool", "teacher"],
		},
	];

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Curso - {currentCourseData?.title}</p>}
			open={isOpen}
			maskClosable={false}
			okText="Cadastrar aula"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values) => {
						const allValues = {
							...values,
							published: courseStatus,
						};
						form.resetFields();
						console.log(allValues);
						setCurrentImgURL("");
						setCourseStatus(false);
						setIsOpen(!isOpen);
					})
					.catch((info) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
			}}
			className="m-modal-students"
		>
			<div className="m-courses-student-modal">
				<div className="m-courses-student-modal__container">
					<h1 className="m-courses-student-modal__container__title">Alunos</h1>
					<div className="m-courses-student-modal__container__input">
						<div className="m-courses-student-modal__container__input__user-number">
							Exibir{" "}
							{
								<Dropdown overlay={menu}>
									<Typography.Text>
										{selectedValue}
										<DownOutlined style={{ marginLeft: "5px" }} />
									</Typography.Text>
								</Dropdown>
							}{" "}
							usuários
						</div>
						<Input placeholder="Pesquisar..." />
						<button
							className="m-courses-student-modal__container__input__btn"
							onClick={() => setIsOpenNewStudentModal(true)}
						>
							+ Adicionar aluno
						</button>
					</div>
					<Table columns={columns} dataSource={data} />
				</div>
			</div>
		</Modal>
	);
};
